export default class QueriesController {
  #api;
  #paths;
  constructor(requestService, paths) {
    this.#api = requestService;
    this.#paths = paths;
  }

  async activateModules({ childId, modules }) {
    try {
      const path = this.#paths.activeModules.activateModules(childId);
      const { data: response } = await this.#api.Post(path, { modules });
      return response;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not activate the modules...');
    }
  }

  async markLessonAsComplete(lessonId) {
    try {
      const path = this.#paths.learnSkills.lessonMarkAsComplete(lessonId);
      const { data: response } = await this.#api.Post(path, { value: true });
      return response;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not mark the lesson as completed.');
    }
  }

  async infoIsHelpfull({ helpful = false, lessonId }) {
    try {
      const path = this.#paths.learnSkills.lessonInfoIsHelpful(lessonId);
      const data = {
        helpful: helpful ? 'helpful' : 'unhelpful',
      };
      const { data: response } = await this.#api.Post(path, data);
      return response;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not update if the information was helpful.');
    }
  }

  async markvideoAsViewed(lessonId) {
    try {
      const path = this.#paths.learnSkills.lessonvideoisViewed(lessonId);
      const { data: response } = await this.#api.Post(path, { value: true });
      return response;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not update if the information to the video.');
    }
  }

  async createClass({ childId, name }) {
    try {
      const path = this.#paths.manageClasses.createClass;
      const { data: response } = await this.#api.Post(path, { child: childId, name: name });
      return response;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not create the class...');
    }
  }

  async deleteClass(classId) {
    try {
      const path = this.#paths.manageClasses.deleteClass(classId);
      const { data: response } = await this.#api.Delete(path);
      return response;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not delete the class...');
    }
  }

  async updateClasses(classesList) {
    try {
      const path = this.#paths.manageClasses.updateClasses;
      const { data: response } = await this.#api.Post(path, { items: classesList });
      return response;
    } catch (error) {
      throw new Error('[Command]: Sorry, I could not create the class...');
    }
  }
}
